export const useOnMouseDown = () => {
    const onMouseDown = (e) => {
        const el = e.currentTarget;
        if (document.activeElement !== el) {
            setTimeout(() => {
                el.select();
            }, 0);
        }
    };
    return onMouseDown;
};
